import React from 'react';
import type { PropsWithChildren } from 'react';

type ProvidersType = [React.ElementType, Record<string, unknown>];

const buildProvidersTree = (componentsWithProps: Array<ProvidersType>) => {
  const initialComponent = ({ children }: PropsWithChildren) => <>{children}</>;
  return componentsWithProps.reduce(
    (
      AccumulatedComponents: React.ElementType,
      [Provider, props = {}]: ProvidersType,
    ) => {
      const WrappedComponent = ({ children }: PropsWithChildren) => {
        return (
          <AccumulatedComponents>
            <Provider {...props}>{children}</Provider>
          </AccumulatedComponents>
        );
      };
      WrappedComponent.displayName = `Provider(${
        (Provider as React.ComponentType).displayName ||
        (Provider as React.ComponentType).name ||
        'Component'
      })`;
      return WrappedComponent;
    },
    initialComponent,
  );
};

export default buildProvidersTree;
